import {useQuery} from '@tanstack/react-query';
import type {PostContentParams} from 'domain/usecases/private/content/post-content';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postContent} from 'presentation/services/postContent';

export const useContentQuery = (params: PostContentParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.CONTENT, params],
		queryFn: ({signal}) => postContent({signal, ...params}),
		enabled: !!params.lista_colection && !!params.numero_item && !!params.operadora,
	});
